var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.$store.state.auth.authenticated) ? _c('div', {
    staticClass: "sidenav"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      },
      "active-class": "active",
      "tag": "a"
    }
  }, [_c('icon', {
    attrs: {
      "icon": "home"
    }
  })], 1), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'invoice.index'
      },
      "active-class": "active",
      "tag": "a"
    }
  }, [_c('icon', {
    attrs: {
      "icon": "file"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('invoice.invoices')) + "\n            ")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'customer.index'
      },
      "active-class": "active",
      "tag": "a"
    }
  }, [_c('icon', {
    attrs: {
      "icon": "users"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('customer.customers')) + "\n            ")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'product.index'
      },
      "active-class": "active",
      "tag": "a"
    }
  }, [_c('icon', {
    attrs: {
      "icon": "package"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('product.products')) + "\n            ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('a', {
    attrs: {
      "href": "#logout"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "icon": "lock"
    }
  })], 1)]), _vm._v(" "), _vm._t("sidenav")], 2) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e806f018","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 0JaN
// module chunks = 15